import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import { store } from './redux';
import { Provider } from 'react-redux';
import { unstable_FeatureFlags as FeatureFlags } from '@carbon/react';
import UserContextProvider from '@/contexts/UserContextProvider';
//import { createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom';
import ApiInterceptor from './lib/ApiInterceptor';
import { SideNavContextProvider } from './contexts/SideNavContextProvider';


const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <UserContextProvider>
      <SideNavContextProvider>
        <ApiInterceptor>
          <FeatureFlags flags={{ 'enable-v12-overflowmenu': true }}>
            <App/>
          </FeatureFlags>
        </ApiInterceptor>
      </SideNavContextProvider>
    </UserContextProvider>
  </Provider>
);
